import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

let $_: any;

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

    url : string;
    show_second_menu : boolean;

    constructor(private router: Router) {

        $_ = this;
        $_.url = '';
        $_.show_second_menu = false;
    }

    ngOnInit() {

        $_.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {

                $_.url = event.url;
                $_.show_second_menu = false;
            }
        });
    }

    test_url(url : string, exact : boolean) {

        if (exact) {

            return $_.url === url;
        }
        else {

            return $_.url.indexOf(url) > -1;
        }
        
    }
}



// WEBPACK FOOTER //
// ./src/app/components/nav/nav.component.ts